<template>
  <div id="bathroom">
    <ul class="scene">
      <!-- Ground -->
      <li class="layer scene__layer scene__layer--ground" data-depth="-0.2">
        <div class="scene__illus scene__illus--ground"></div>
      </li>

      <!-- Foreground (people) -->
      <li class="layer scene__layer scene__layer--foreground" data-depth="0.0">
        <div class="sprite sprite--door" data-frames="49" data-framerate="15" data-delay="1000" data-interval="3000"></div>
        <div class="sprite sprite--girl" data-frames="49" data-framerate="20" data-delay="0" data-interval="0"></div>
        <img class="scene__illus scene__illus--foreground" src="../../assets/svg/bathroom/foreground.svg" alt="">
      </li>

      <!-- Background (landscape) -->
      <li class="layer scene__layer scene__layer--background" data-depth="0.1">
        <div class="sprite sprite--dryer" data-frames="49" data-framerate="20" data-delay="0" data-interval="0"></div>
        <img class="scene__illus scene__illus--background" src="../../assets/svg/bathroom/background.svg" alt="">
        <div class="window__clouds">
          <img class="window__cloud window__cloud--first" src="../../assets/svg/scene__clouds-1.svg" alt="">
          <img class="window__cloud window__cloud--second" src="../../assets/svg/scene__clouds-2.svg" alt="">
          <img class="window__cloud window__cloud--third" src="../../assets/svg/scene__clouds-1.svg" alt="">
          <img class="window__cloud window__cloud--fourth" src="../../assets/svg/scene__clouds-1.svg" alt="">
          <img class="window__cloud window__cloud--fifth" src="../../assets/svg/scene__clouds-1.svg" alt="">
        </div>
      </li>

      <!-- Sky  -->
      <li class="scene__sky"></li>
    </ul>
  </div>
</template>

<script>
  import { ParallaxClass } from '../../classes/ParallaxClass'
  import { Modals } from '../../classes/Modals'
  import { Clouds } from '../../classes/Clouds'
  import { Sprites } from '../../classes/Sprites'

  const parallax = new ParallaxClass()
  const modals = new Modals()
  const clouds = new Clouds([
    [ '.window__cloud--first', 160 ],
    [ '.window__cloud--second', 120 ],
    [ '.window__cloud--third', 110 ],
    [ '.window__cloud--fourth', 150 ],
    [ '.window__cloud--fifth', 130 ]
  ])
  const sprites = new Sprites()

  export default {
    name: 'view-5',
    activated () {
      this.$nextTick(() => {
        setTimeout(() => {
          parallax.addToPage(this.$route.name)
          modals.addToPage(this.$route.name)
          clouds.animate(this.$route.name)
          sprites.animate(this.$route.name)
        }, 500)
      })
    },
    deactivated () {
      modals.remove()

      parallax.disable()
      clouds.disable()
      sprites.disable()
    }
  }
</script>



// WEBPACK FOOTER //
// SceneBathroom.vue?ceb9b374